<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Distribución de Solicitudes Export UK con Inspección documental</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                       aria-controls="collapseFiltros">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">
                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPais">Punto Inspección</label>

                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="listPuntoInspeccion"
                                               placeholder="-- Seleccione un PCF --"
                                               [readonly]="!listPuntoInspeccion || listPuntoInspeccion.length === 0"
                                               [loading]="!listPuntoInspeccion || listPuntoInspeccion.length === 0"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPuntoInspeccion"
                                               notFoundText="PIF no encontrado"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPais">Año</label>

                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="listAnno"
                                               placeholder="-- Seleccione un Año --"
                                               [readonly]="!listAnno || listAnno.length === 0"
                                               [loading]="!listAnno || listAnno.length === 0"
                                               bindLabel="Anno"
                                               bindValue="Anno"
                                               formControlName="IdAnno"
                                               notFoundText="Año no encontrado"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectAnno()">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPais">Número de Semana</label>

                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="listNumeroSemana"
                                               placeholder="-- Seleccione una Semana --"
                                               [loading]="((!listNumeroSemana || listNumeroSemana.length === 0) && (form.value.IdAnno > 0))"
                                               bindLabel="Descripcion"
                                               bindValue="NumeroSemana"
                                               formControlName="IdNumeroSemana"
                                               notFoundText="Número de Semana no encontrado"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearch($event)"><i class="fa fa-search"></i> Buscar</button>

                                    </div>

                                    <div class="btn-group">

                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanForm($event)"><i class="fa fa-eraser"></i> Limpiar</button>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
